export const brand = {
  yellow: "#FFCD00",
  pink: "#FF87B4",
  green: "#00D383",
  red: "#E40000",
  orange: "#FFAB30",
  blue: "#50C9FC",
  grey: "#EEEEEE",
  white: "#FFFFFF",
  black: "#212121",
} as const;

export const extended = {
  red: {
    shade100: "#FEE9E9",
    shade200: "#FBC8C8",
    shade300: "#F9A7A7",
    shade400: "#F78383",
    shade600: brand.red,
    shade800: "#9E0000",
  },
  orange: {
    shade100: "#FFEBCE",
    shade200: "#FFCC82",
    shade300: brand.orange,
    shade400: "#E29422",
    shade600: "#9B6617",
    shade800: "#694510",
  },
  yellow: {
    shade100: "#FFF8D9",
    shade200: "#FFE166",
    shade500: brand.yellow,
    shade600: "#E5B800",
  },
  green: {
    shade100: "#CEF7E7",
    shade200: "#7DE9C0",
    shade300: brand.green,
    shade400: "#00BD75",
    shade600: "#008251",
    shade800: "#005837",
  },
  blue: {
    shade100: "#D6F2FE",
    shade200: "#96DFFD",
    shade300: brand.blue,
    shade400: "#00AFF8",
    shade600: "#0078AB",
    shade800: "#005274",
  },
  pink: {
    shade100: "#FFE8F0",
    shade200: "#FFC5DB",
    shade300: "#FFA1C4",
    shade400: brand.pink,
    shade500: "#EC7AA5",
  },
} as const;

export const grayscale = {
  shade50: "#FAFAFA",
  shade100: brand.grey,
  shade200: "#D5D5D5",
  shade400: "#A5A5A5",
  shade600: "#717171",
} as const;
